import { Component } from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ParameterService } from 'src/app/shared/service/params/param';
import { LocalStorageService } from 'src/app/shared/service/storage/localstorage.service';
import { AddServiceComponent } from '../add-service/add-service.component';
import { EditServiceComponent } from '../edit-service/edit-service.component';
import { Service } from 'src/app/shared/models/service';
import { Constant } from 'src/app/shared/service/utils/contant';
import { FecthDataService } from 'src/app/shared/service/fetchservice/fetchservice';
import { NgxUiLoaderService } from 'ngx-ui-loader';

@Component({
  selector: 'app-service',
  templateUrl: './service.component.html',
  styleUrl: './service.component.scss'
})


export class ServiceComponent {

  // breadcrumb items
  breadCrumbItems: Array<{}>;

  submitted: boolean;

  serviceData: any = [];

  modalRef: NgbModalRef | null = null;

  itemToDelete!: Service;
  paginatedProjets = [];
  firstProjets: number = 0; 
  rowsProjets: number = 10; 
  totalRecords: number = 0; 
  filteredData: any[] = []; 
  isLoading: boolean = false;
  searchTerm: string;
  filteredtems: any = [];
  constructor(
    private modalService: NgbModal,
    public formBuilder: UntypedFormBuilder,
    private paramservice: ParameterService,
    private localstorage: LocalStorageService,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private fetchService:FecthDataService,
    private laoader:NgxUiLoaderService,

  ) { 

    this.fetchService.actionCreated$.subscribe(() => {
      this.fetchData();
    });
  }

  ngOnInit(): void {
  }

  fetchData() {
    this.isLoading === false;
    this.paramservice.fetchDataService().subscribe(
      (response: any) => {

        this.serviceData = response.data;
        this.filteredData = [...this.serviceData]; 
        this.totalRecords = this.filteredData.length;
        this.updatePaginatedProjets();
        this.isLoading = true;
        ////console.log("this.actionData",this.serviceData);
      },
      (error) => {
        //console.log("une erreur est survenu",error);
      }

    );
  }

  onPageChangeProjets(event) {
    this.firstProjets = event.first ;
    this.rowsProjets = event.rows ;
    this.updatePaginatedProjets();
  }

  // Méthode pour mettre à jour les données paginées des projets
  updatePaginatedProjets() {
    const start = this.firstProjets;
    const end = start + this.rowsProjets;
    this.paginatedProjets = this.filteredData.slice(start, end);
  }


  openModal() {
    this.modalService.open(AddServiceComponent, {
      centered: true,
      backdrop: 'static',
      size: 'lg'

    });
  }

  EditModal(action: any) {
    this.localstorage.saveService(action)
    const modalRef = this.modalService.open(EditServiceComponent, {
      backdrop: 'static',
      centered: true,
      size:'lg'
    },);
  }

  confirm1(event: Event) {
    this.confirmationService.confirm({
      target: event.target as EventTarget,
      message: 'Êtes-vous sûr de vouloir continuer ?',
      header: 'Confirmation',
      icon: 'pi pi-exclamation-triangle',
      acceptIcon: 'pi pi-check',
      rejectIcon: 'pi pi-times',
      rejectButtonStyleClass: 'p-button-text',
      acceptLabel: 'Oui', // Définir le libellé du bouton "Oui"
      rejectLabel: 'Non', // Définir le libellé du bouton "Non"
      accept: () => {
        //this.messageService.add({ severity: 'info', summary: Constant.suiviTitle, detail: 'Vous avez acepter' });
        this.laoader.start();
        this.paramservice.deleteService(event).subscribe(

          (response: any) => {

            ////console.log("la reponse du webserice",response);
            this.laoader.stop();
            this.messageService.add({ severity: 'info', summary: Constant.suiviTitle, detail: response.message });


          },
          (error:any) => {
            this.laoader.stop();

        //    //console.log("une erreur est survenu",error);
            this.messageService.add({ severity: 'error', summary: Constant.suiviTitle, detail: error });
          },
        )
      },
      reject: () => {
        this.messageService.add({ severity: 'error', summary: Constant.suiviTitle, detail: 'Vous avez rejeté', life: 3000 });
      }
    });
  }


//filtre les donnees par un mot cle
filterData() {
  const lowerSearchTerm = this.searchTerm.toLowerCase();

  if (!lowerSearchTerm.trim()) {
    this.filteredData = [...this.serviceData];
  } else {
    const searchWords = lowerSearchTerm.split(' ').filter(w => w);

    this.filteredData = this.serviceData.filter((item: any) => {
      const libelle = item.libelle?.toLowerCase() || "";
      const direction = item.direction_id?.toLowerCase?.() || ""; // si direction est string

      return searchWords.every(word =>
        libelle.includes(word) ||
        direction.includes(word)
      );
    });
  }

  // mise à jour pagination
  this.totalRecords = this.filteredData.length;
  this.firstProjets = 0;
  this.updatePaginatedProjets();
}

}
